export default __webpack_public_path__ + "static/media/banner-right.2ffee4cf.png";